/**
 * Cleans a string for safe use as a URL segment.
 * - Trims whitespace
 * - Replaces non-allowed characters (except 0-9, a-z, A-Z, (), %, -) and %20 with hyphens
 * - Removes parentheses
 * - Removes leading zeros
 *
 * @param {string} value - The string to sanitize for use in a URL segment.
 * @returns {string} The sanitized string.
 */
export const sanitizeUrlSegment = (value) => value?.trim()
  .replace(/[^0-9a-zA-Z()%-]+|%20/g, '-')
  .replace(/[()]/g, '')
  .replace(/^0+/g, '') || '';